// extracted by mini-css-extract-plugin
export default {"Layout":"Hocs_Layout__3jqe2","Header":"Hocs_Header__wYtiM","Content":"Hocs_Content__tmOdD","Footer":"Hocs_Footer__ndIni","Card":"Hocs_Card__zKUQG"};